import { FirebaseError, initializeApp } from "firebase/app";
import {
	type MessagePayload,
	type NextFn,
	getMessaging,
	getToken,
	onMessage,
} from "firebase/messaging";
import { ref } from "vue";

export function useFirebaseServiceWorker() {
	const firebaseConfig = {
		apiKey: "AIzaSyDVkBvAJqkTYkEhA2j6VuWgH2HobUsqzKY",
		authDomain: "ulno-1557913587891.firebaseapp.com",
		databaseURL: "https://ulno-1557913587891.firebaseio.com",
		projectId: "ulno-1557913587891",
		storageBucket: "ulno-1557913587891.appspot.com",
		messagingSenderId: "676248622318",
		appId: "1:676248622318:web:f29d36155596fc7e69cfff",
		measurementId: "G-8SKM713FJ9",
	};

	const firebaseApp = initializeApp(firebaseConfig);
	const messaging = getMessaging(firebaseApp);

	// Safari on iOS does not support the Notification API in a non-PWA context.
	// So users need to install the app as a PWA to receive notifications.
	const isIosAndNeedsPWA = window.navigator.userAgent.includes("iPhone") && !("Notification" in window);

	function getNotificationPermission(): NotificationPermission {
		try {
			return Notification.permission;
		} catch (error) {
			console.error("Error getting notification permission:", error);
			return "default";
		}
	}

	const notificationPermission = ref<NotificationPermission>(getNotificationPermission());

	async function getFirebaseToken(): Promise<string | null> {
		try {
			const token = await getToken(messaging, {
				vapidKey:
					"BCbsX73CGzbBy0Ecox8VpsIbfnbdHhDaSFQYimoLgTjWRLBp0IHVpMxp1Dj6dn9sOhA4wMcN02JR-YbRkaZINeo",
			});
			if (token) {
				await fetch("https://subcribetotopic-2q5lh22v2q-ew.a.run.app", {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify({ token }),
				});
				return token;
			}
			console.log(
				"No registration token available. Request permission to generate one.",
			);
			return null;
		} catch (err) {
			if (err instanceof FirebaseError) {
				console.log(
					"Failed to get Firebase token, user probably denied permission",
				);
				return null;
			}
			throw err;
		}
	}

	async function registerFirebaseMessaging(
		onMessageCallback: NextFn<MessagePayload>,
	) {
		const token = await getFirebaseToken();
		notificationPermission.value = getNotificationPermission();

    if (token) console.log("Successfully subscribed to push notifications");

		onMessage(messaging, onMessageCallback);
	}

	return {
		registerFirebaseMessaging,
		getFirebaseToken,
		notificationPermission,
		isIosAndNeedsPWA,
	};
}
